import { Permission } from '@statsbomb/kitbag-components/types/components/ShareModal/types';
import { OptionOptional } from '@/types/generic';

export const hasIs360 = (optional?: OptionOptional): optional is { is360: boolean } =>
  typeof optional === 'object' && optional !== null && 'is360' in optional && optional.is360 !== undefined;

export const hasCountryCode = (optional?: OptionOptional): optional is { countryCode: string | null } =>
  typeof optional === 'object' && optional !== null && 'countryCode' in optional && optional.countryCode !== undefined;

export const isNonOwnerPermission = <T extends { permission?: Permission }>(
  user: T,
): user is T & { permission: Exclude<Permission, 'own'> } => !!user.permission && user.permission !== 'own';

// checks if a value is null or undefined
export const isNullish = (value: unknown): value is undefined | null => value === undefined || value === null;

// narrows an array to guarantee a defined first element
export const isNonEmptyArray = <T>(array: T[]): array is [T, ...T[]] => array.length > 0;

// checks if a value is a valid member of an enum (or any object used as an enum)
export const isValidEnumValue = <T extends Record<string, unknown>>(enumObj: T, value: unknown): value is T[keyof T] =>
  Object.values(enumObj).some(enumValue => enumValue === value);
